import React from 'react';
import styled from 'styled-components';
import { AppColors } from 'helpers';
import { Div, HorizontalView, VerticalView } from 'vendor-deprecated/Wrapper';
import { TextDisplay } from 'vendor-deprecated/Text';
import { SVGIcon } from 'vendor-deprecated/Icon';
import { useTranslationText } from 'locale';
import { useAppSetting } from 'helpers/useAppSetting';
import { ICourse } from 'types/types';
import { useHistory } from 'react-router-dom';

const BuyNowButton = styled.button<{ disabled?: boolean }>`
  position: relative;
  margin-top: 10px;
  font-weight: bold;
  font-size: 15px;
  width: 100%;
  border-style: none;
  border-radius: 4px;
  padding: 15px;
  border:1px solid  ${AppColors.DARK};
  color: ${AppColors.DARK};
  background: ${AppColors.WHITE};
  outline: none;
  cursor: ${(props) => (props.disabled ? 'default;' : 'pointer;')}
  opacity:${(props) => (props.disabled ? '0.2;' : '1;')}
`;

const AddToCartButton = styled.button<{ disabled?: boolean }>`
  position: relative;
  margin-top: 15px;
  font-weight: bold;
  font-size: 15px;
  width: 100%;
  border-style: none;
  border-radius: 4px;
  padding: 15px;
  color: ${AppColors.WHITE};
  background: ${AppColors.RED2};
  outline: none;
  cursor: ${(props) => (props.disabled ? 'default;' : 'pointer;')}
  opacity:${(props) => (props.disabled ? '0.7;' : '1;')}
  &:hover {
    opacity: 0.7;
  }
`;

const BookingButton = styled.button<{ disabled?: boolean }>`
  position: relative;
  margin-top: 15px;
  font-weight: bold;
  font-size: 15px;
  width: 100%;
  border-style: none;
  border-radius: 4px;
  padding: 15px;
  color: ${AppColors.WHITE};
  background: ${AppColors.PRIMARY};
  outline: none;
  cursor: ${(props) => (props.disabled ? 'default;' : 'pointer;')}
  opacity:${(props) => (props.disabled ? '0.7;' : '1;')}
  &:hover {
    opacity: 0.7;
  }
`;

const i18key = 'public.courseDetails.card';

export const PaymentButton = React.memo(
  (props: {
    disabled?: boolean;
    added: boolean;
    course: ICourse;
    setAdded: (added: boolean) => void;
    onAddToCart: () => void;
    onBuyNow: () => void;
  }) => {
    const history = useHistory();
    const { appLayout } = useAppSetting();
    const { translation } = useTranslationText();

    const onBooking = () => {
      history.push(`/booking/${props.course.createdBy}/${props.course.id}`);
    };

    return (
      <VerticalView fullWidth alignContent={'center'}>
        <BuyNowButton disabled={props.disabled} onClick={props.onBuyNow}>
          <HorizontalView height={'100%'} alignContent={'center'}>
            <TextDisplay marginLeft={'10px'}>{translation(`${i18key}.buyNow`)}</TextDisplay>
          </HorizontalView>
        </BuyNowButton>
        <AddToCartButton
          disabled={props.disabled || props.added}
          onClick={(e) => {
            e.preventDefault();
            props.onAddToCart();
            props.setAdded(true);
          }}
        >
          <HorizontalView height={'100%'} alignContent={'center'}>
            {props.added && <SVGIcon name={'check-circle'} color={AppColors.WHITE} />}
            <TextDisplay marginLeft={'10px'}>{translation(`${i18key}.addToCard`)}</TextDisplay>
          </HorizontalView>
        </AddToCartButton>
        <BookingButton onClick={onBooking}>
          <HorizontalView height={'100%'} alignContent={'center'}>
            <SVGIcon name={'clock'} color={AppColors.WHITE} />
            <TextDisplay marginLeft={'10px'}>{translation(`${i18key}.booking`)}</TextDisplay>
          </HorizontalView>
        </BookingButton>
        <Div marginTop={'10px'}>
          <TextDisplay size={'11px'} color={appLayout.isMobile ? AppColors.WHITE : AppColors.GRAY_DARK}>
            {translation(`${i18key}.refund`)}
          </TextDisplay>
        </Div>
      </VerticalView>
    );
  },
);
